import { Http, Urls } from '@/module/http'
import { OptionDevice, ParamBindData, ResponseData } from '@/module/response'
import { Options, Vue } from 'vue-class-component'
import { Tool } from '@/module/tool'

@Options({
  props: ['excelBindData'],
  components: {},
  emits: {
    click: null,
    closebind: () => {
      return true
    },
    showmessage: () => {
      return true
    },
    updatedata: () => {
      return true
    }
  }
})
export default class StockBind extends Vue {
    optionDeviceList = []

    isShowBindData = false

    currentBindDeviceID = -1
    currentBindDevice = ''

    postBindData: ParamBindData[] = []

    selectedBindData (value: OptionDevice) {
      const bindData = this.postBindData.find((value) => {
        return value.code === this.currentBindDevice
      })

      if (bindData === undefined) {
        const data: ParamBindData = {
          code: this.currentBindDevice,
          optionCode: value.code,
          deviceID: value.id
        }
        this.postBindData.push(data)
      } else {
        bindData.optionCode = value.code
        bindData.deviceID = value.id
      }

      this.setHtmlStatus(value)
      this.isShowBindData = false
    }

    setHtmlStatus (value: OptionDevice) {
      const bindDeviceEl = document.getElementById('bind_device_' + this.currentBindDeviceID) as HTMLElement
      if (bindDeviceEl != null) {
        bindDeviceEl.innerHTML = this.contentLength(value.code + ' ' + value.productName, 30)
      }

      const bindOptionNameEl = document.getElementById('bind_option_name_' + value.id) as HTMLInputElement
      if (bindOptionNameEl != null) {
        bindOptionNameEl.remove()
      }

      if (this.$props.excelBindData.bindDevice.length === this.postBindData.length) {
        const submitButtonEl = document.getElementById('submitButton') as HTMLInputElement
        if (submitButtonEl != null) {
          submitButtonEl.disabled = false
        }
      }
    }

    showBindData (index: number, value: string) {
      this.currentBindDeviceID = index
      this.currentBindDevice = value
      this.isShowBindData = true
    }

    commitBindData () {
      const data = {
        type: this.$props.excelBindData.types,
        deviceInfos: this.postBindData
      }
      Http.post(Urls.stock_bind, data).then(() => {
        this.$emit('showmessage', this.$i18n.t('bindSuc'))
        this.$emit('updatedata')
        this.$emit('closebind')
      }, (err: ResponseData) => {
        this.$emit('showmessage', err.Msg)
      })
    }

    contentLength (str: string, num: number) {
      return Tool.stringLength(str, num)
    }
}
